export default "__VITE_ASSET__5WwRCOhE__"